var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeStar5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.04761L13.8206 15.5036L0 14.5097V17.4912L9.96678 27.2307L7.6412 37.964V41.0117L20 34.5188L32.3588 41.0117V37.964L30.0332 27.2307L40 17.4912V14.5097L26.1794 15.5036L20 3.04761Z",
    fill: "#00791E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0L13.8206 12.5222L0 14.5099L9.96678 24.2493L7.6412 37.9641L20 31.4712L32.3588 37.9641L30.0332 24.2493L40 14.5099L26.1794 12.5222L20 0Z",
    fill: "#85DD9B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStar5);
export default __webpack_public_path__ + "static/media/Home_Star_5.f21b31117b19a548c1d6dfd9bc24a9a1.svg";
export { ForwardRef as ReactComponent };